import React from "react";

export function formatArchivedAt(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return "—";
  return d.toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Lists archived records with who archived them, when, and a Restore action.
export default function ArchivedList({
  status,
  items,
  getKey,
  renderName,
  renderDetail,
  restoringKey,
  onRestore,
  onRetry,
  emptyTitle,
  emptyText,
}) {
  if (status === "loading") {
    return (
      <div className="adm-surface" aria-busy="true">
        <div className="adm-state">
          <span className="adm-skel" style={{ width: 220 }} />
          <span className="adm-skel" style={{ width: 160 }} />
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="adm-surface">
        <div className="adm-state" role="alert">
          <p className="adm-state__title">Couldn't load archived records</p>
          <p className="adm-state__text">Check your connection, then try again.</p>
          <button type="button" className="adm-btn adm-btn--secondary" onClick={onRetry}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="adm-surface">
        <div className="adm-state">
          <p className="adm-state__title">{emptyTitle}</p>
          <p className="adm-state__text">{emptyText}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="adm-surface">
      <div className="adm-scroll">
        <table className="adm-table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Archived</th>
              <th scope="col">Archived by</th>
              <th scope="col" className="adm-col-actions">
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              const key = getKey(item);
              return (
                <tr key={key} className="adm-row adm-row--static">
                  <td data-label="Name">
                    <div className="adm-list__primary">{renderName(item)}</div>
                    {renderDetail && <div className="adm-list__secondary">{renderDetail(item)}</div>}
                  </td>
                  <td data-label="Archived">{formatArchivedAt(item.archivedAt)}</td>
                  <td data-label="Archived by">
                    {item.archivedBy || <span className="adm-muted">Unknown</span>}
                  </td>
                  <td className="adm-col-actions">
                    <button
                      type="button"
                      className="adm-btn adm-btn--secondary adm-btn--sm"
                      onClick={() => onRestore(item)}
                      disabled={Boolean(restoringKey)}
                    >
                      {restoringKey === key ? "Restoring…" : "Restore"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
